//Imports
import React from "react";
import ResponsiveAppBar from "../../components/appbar";
import Footer from "../../components/footer";


//Function

export default function Updatelog(){
    return(
        <div>
            <ResponsiveAppBar/>
            <h1 className={"Updatelog-head"}>UPDATE LOG</h1>

            <Footer/>
        </div>
    )
}
